var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.state)?[_c('NETVSIcon',{staticStyle:{"color":"var(--success)"},attrs:{"icon":"check"}}),_vm._t("true_text")]:[_c('NETVSIcon',{staticStyle:{"color":"var(--danger)"},attrs:{"icon":"close"}}),_vm._t("false_text")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }